(function HotelEngineCommissionAdjuster($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['commission-adjustment'],
		props: {
			room: {
				type    : Object,
				required: true,
			},
			numNights: {
				type    : Number,
				required: true,
			},
			totalRooms: {
				type    : Number,
				required: true,
			}
		},
		template: '#he-commission-adjuster',
		data() {
			return {
				baseUri             : Adzuki.base_uri,
				cpCommission        : 0.00,
				commissionValue     : 0.00,
				lowMarkupPercentage : Adzuki.markupLowPercentage,
				highMarkupPercentage: Adzuki.markupHighPercentage,
				adminFeePercentage  : Adzuki.markupAdminFeePercentage,
				additionalSavings   : 0.00,
				selectedBlock       : null,
				markupType          : 'fixed',
				markUpValue         : 0.00,
				initialCommission   : 0.00,
				isUpdatingAdditional: false,
				isUpdatingCommission: false,
				finalCommission     : {},
			};
		},
		computed: {
			computedCommission() {
				return Number(this.initialCommission - this.additionalSavings).toFixed(2);
			},
			computedMarkup() {

				if (this.markupType === 'fixed') {
					return this.markUpValue.toFixed(2);
				}

				return (this.roomPrices.totalPrice * (this.markUpValue / 100)).toFixed(2);

			},
			roomPrices() {
				return Adzuki.HotelEngine.computeRatePrices(this.room?.room, {
					numNights: this.numNights || 1,
					numRooms : this.totalRooms || 1,
				});
			},
		},
		methods: {
			changeCommission() {
				let markupPerc              = 0.0;
				const computedCommission    = Number(this.computedCommission) || 0;
				const computedMarkup        = Number(this.computedMarkup) || 0;
				const additionalSavings     = this.additionalSavings || 0;
				const markup                = this.markUpValue || 0;
				const roomRate              = this.roomPrices.totalPrice || 0;
				const markupLowPerc         = this.lowMarkupPercentage || 0;
				const markupHighPerc        = this.highMarkupPercentage || 0;
				const adminFeePerc          = this.adminFeePercentage || 0;
				const markupType            = this.markupType;
				const currentAdjustmentType = this.selectedBlock;
				const admin_fee             = Number(computedMarkup * ( adminFeePerc / 100));
				const newAgentCommission    = Number( computedCommission + computedMarkup - admin_fee);
				const maxMarkup             = Number(this.room.room.pricing.selling_price * (markupHighPerc / 100));
				const markupOverrideText    = "Please review the changes carefully.";


				// Markup Logic
				if (currentAdjustmentType === 'markup') {
					if (markupType === 'percentage') {
						markupPerc = Number(markup || 0);
					} else {
						markupPerc = Number((markup / roomRate) * 100);
					}

					console.log(markupPerc, typeof markupPerc, 'Mark Up Percentage');

					if (markupPerc > markupHighPerc) {
						alert(
							`Sorry, the markup amount you specified is higher than allowed (${markupHighPerc}%). Please re-enter.`
						);

						this.clearAdjustments(); // Reset adjustments
						return;
					}

					if (markupPerc >= markupLowPerc && markupPerc <= markupHighPerc) {
						alert(
							`The markup you provided is higher than the normal expected percentage (${markupLowPerc}%). This is just a warning, and it will be added. Agent commission amount is now ${this.formatCurrency(newAgentCommission)}. ${markupOverrideText}`
						);
					}

					if (markupPerc < markupLowPerc) {
						alert(
							`Markup applied. Agent commission amount is now ${this.formatCurrency(newAgentCommission)}. ${markupOverrideText}`
						);
					}




					this.finalCommission.paymentMarkup      = markupPerc;
					this.finalCommission.maxMarkUp          = maxMarkup;
					this.finalCommission.additionalSavings  = 0;
					this.finalCommission.adjustedCommission = newAgentCommission;

				}

				// Discount Logic
				if (currentAdjustmentType === 'discount') {
					const confirmMessage = `Are you sure you want to save the adjustments and REDUCE your commission by giving ${this.formatCurrency(additionalSavings)} savings to the customer? Agent commission amount will become ${this.formatCurrency(newAgentCommission)}.`;

					if (confirm(confirmMessage)) {

						// On confirmation
						this.finalCommission.paymentMarkup      = 0;
						this.finalCommission.additionalSavings  = additionalSavings;
						this.finalCommission.adjustedCommission = newAgentCommission;
					} else {
						// On cancellation
						this.clearAdjustments(); // Reset adjustments
					}
				}

				this.$emit('commission-adjustment', this.finalCommission);
			},
			clearAdjustments() {
				this.additionalSavings = 0.00;
				this.commissionValue   = 0.00;
				this.markupType        = 'fixed';
				this.markUpValue       = 0.00;
				this.selectedBlock     = null;
			},
			formatCurrency(amount) {
				return new Intl.NumberFormat('en-US', {
					style   : 'currency',
					currency: 'USD'
				}).format(amount);
			},
			getCpCommission() {
				let formData = new FormData();

				formData.append('selling_price', this.room.room.pricing.selling_price || 0.00);
				formData.append('commission', this.room.room.pricing.agent_commission || 0.00);

				fetch(this.baseUri + '/HotelEngine/getCpCommission', {
					method: 'POST',
					body  : formData,
				})
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error while fetching suggestions: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						if (data) {
							this.cpCommission = parseFloat(data);
						}
					})
					.catch(error => {
						console.error('Error:', error);
						alert('Error getting commission!');
					});
			},
			toggleCommissionBlock(blockName) {

				if (blockName === 'markup') {
					this.additionalSavings = 0.00;
					this.commissionValue = this.initialCommission;
				} else {
					this.markUpValue = 0.00;
				}

				this.selectedBlock = blockName;
			}
		},
		watch: {
			commissionValue(newValue) {
				if (!this.isUpdatingAdditionals) {
					this.isUpdatingCommission = true;
					this.additionalSavings = Math.round((this.initialCommission - newValue) * 100) / 100;
					this.isUpdatingCommission = false;
				}
			},
			additionalSavings(newValue) {
				if (!this.isUpdatingCommission) {
					this.isUpdatingAdditionals = true;
					this.commissionValue = Math.round((this.initialCommission - newValue) * 100) / 100;
					this.isUpdatingAdditionals = false;
				}
			},
			cpCommission(newValue) {
				this.initialCommission = parseFloat(this.room.room?.pricing.agent_commission - newValue).toFixed(2);
				this.commissionValue   = this.initialCommission;
			}
		},
		mounted() {
			if (this.room) {
				this.getCpCommission();
			}

		}
	};

	Adzuki.VueComponents.HotelEngineCommissionAdjuster = component;
}(jQuery, window.Adzuki || {}));
